import React from 'react'

export const TEXT_FR = {
    title: 'Ihr Alkohol-Konsum im Vergleich',
    lead:
        '  Wie viel Bier, Wein und Schnaps trinken Sie im Vergleich mit den anderen Leserinnen und Lesern? Und ab wann wird es riskant? Unser Alkoholrechner weiss es.',
    date: 'Aktualisiert am 31. XXXXXXX 2020',
    intro:
        'Unser interaktives Tool zeigt Ihnen, wie viel Sie im Vergleich zu den anderen Leserinnen und Lesern trinken – und wie Sie im Schweizer Vergleich dastehen.',

    agegroups: {
        age_15_24: '15-24-jährig',
        age_25_34: '25-34-jährig',
        age_35_44: '35-44-jährig',
        age_45_54: '45-54-jährig',
        age_55_64: '55-64-jährig',
        age_65_74: '65-74-jährig',
        age_75: '75+ -jährig'
    },
    calculator: {
        title: 'Wie viele Standardgläser Alkohol trinken Sie pro Woche?',
        lead: (
            <>
                Ein <b>Standardglas Alkohol</b> enthält zwischen 10 und 12 Gramm reinen
                Alkohol. So viel enthält ungefähr eine Stange Bier (3 Deziliter), ein
                Glas Wein (1 Deziliter) oder ein Gläschen Schnaps (0,3 Deziliter).
            </>
        ),
        drinks: ['Stange Bier', 'Glas Wein', 'Schnaps'],
        questions: [
            ['Ihr Geschlecht? ', 'Frau', 'Mann'],
            [
                'Wie häufig trinken Sie in der Woche?',
                'nie',
                'weniger als 1 Tag pro Woche',
                'an 1 bis 2 Tagen pro Woche',
                'an 3 bis 6 Tagen pro Woche',
                'täglich'
            ],
            [
                'Trinken Sie mindestens einmal im Monat mehr als 5 Standardgläser (Männer) bzw. 4 Standardgläser (Frauen) an einem Tag?',
                'Ja',
                'Nein'
            ],
            [
                'Ihre Altersgruppe?',
                '15–24 Jahre',
                '25–34 Jahre',
                '35–44 Jahre',
                '45–54 Jahre',
                '55–64 Jahre',
                '65–74 Jahre',
                '75+ Jahre'
            ]
        ],
        disclaimer:
            'Alle Daten werden ausschliesslich für die Visualisierung verwendet. Sie werden nicht weitergegeben, sind anonym und werden nicht zu persönlichen Daten zugeordnet.',
        buttons: ['Auswerten', 'Danke für Ihre Teilnahme!'],
        fillout: "Vervollständigen Sie Ihre Angaben um zur Auswertung zu gelangen!"
    },
    risk: {
        gender: {
            m: ['Teilnehmer', 'Teilnehmern'],
            f: ['Teilnehmerinnen', 'Teilnehmerinnen']
        },
        user: {
            none: <>Sie sind abstinent.</>,
            low: <>Ihr Konsum ist risikoarm.</>,
            middle: <>Ihr Konsum ist möglicherweise risikoreich.</>,
            high: (
                <>
                    Ihr Konsum ist <b>chronisch risikoreich</b> oder Sie sind ein{' '}
                    <b>Rauschtrinker</b>.
                </>
            )
        },
        frequency: {
            none: 'abstinent leben',
            low: 'riskikoarm trinken',
            middle: 'möglichwerweise risikoreich trinken',
            high: ' risikoreich trinken'
        },
        groups: {
            none: (
                <>
                    <h5>Abstinent</h5>Zu dieser Stufe gehören alle Personen die keinen
                    Alkohol trinken.
                </>
            ),
            low: (
                <>
                    <h5>Risikoarm</h5>
                    <ul>
                        <li>
                            Wenn <b>Frauen</b> täglich nicht mehr als ein Standardglas Alkohol
                            (10 bis 12 Gramm) trinken, ist das wenig schädlich. Wenn es
                            ausnahmsweise etwas mehr wird, nicht mehr als 4 Gläser. An
                            mindestens zwei Tagen pro Woche auf Alkohol verzichten.
                        </li>
                        <li>
                            Für <b>Männer</b> liegt die Grenze bei 20 bis 24 Gramm, was zwei
                            Standardgläsern Alkohol am Tag entspricht. Wenn es mehr wird,
                            nicht mehr als 5 Gläser. An mindestens zwei Tagen pro Woche auf
                            Alkohol verzichten.
                        </li>
                    </ul>
                    Rund 80 Prozent der in der Schweiz lebenden Bevölkerung im Alter von
                    15 bis 74 Jahren trinken gemäss Bundesamt für Statistik risikoarm bzw.
                    keinen Alkohol.
                </>
            ),
            middle: (
                <>
                    <h5>Möglicherweise risikoreich</h5>
                    In diese Stufe fallen alle Personen die zwischen risikoarm und
                    chronisch risikoreich bzw. Rauschtrinken liegen.
                </>
            ),
            high: (
                <>
                    <h5>Chronisch risikoreich oder Rauschtrinken</h5>
                    <ul>
                        <li>
                            <b>Chronisch risikoreicher Konsum bedeuted:</b> ≥ 4 Standardgläser eines
                            alkoholischen Getränks pro Tag bei Männern, ≥ 2 Gläser bei Frauen.
                        </li>
                        <li>
                            Von <b>Rauschtrinken</b> spricht man in der Alkoholforschung, wenn
                            Männer fünf Standardgläser Alkoholisches oder mehr und Frauen vier
                            Gläser oder mehr innerhalb weniger Stunden mindestens einmal pro
                            Monat trinken.
                        </li>
                    </ul>
                    5% der Schweizer Bevölkerung trinken gemäss dem Bundesamt für
                    Statistik chronisch risikoreich und 16% betrinken sich mindestens
                    einmal im Monat. Das bedeutet, dass rund jede fünfte Person Alkohol
                    missbräuchlich trinkt, das sind über eine Million Schweizerinnen und
                    Schweizer.
                </>
            )
        }
    },
    evaluation: {
        title:
            ' So viel und oft trinken Sie im Vergleich',
        userMarker: 'Hier stehen Sie!',
        frequency: [
            'Täglich',
            '3 bis 6 Tagen pro Woche',
            '1 bis 2 Tagen pro Woche',
            '< 1 Tag pro Woche',
            'nie'
        ],
        chart1: {
            title: 'So viel Standardgläser Alkohol pro Woche trinken Sie…',
            sub: ['…im Vergleich zu den ', ' Teilnehmerinnen und Teilnehmern'],
            gender: ['Männer', 'Frauen'],
            key: [
                'Anzahl der alkoholischen Standardgläser pro Woche',
                'Anzahl der Teilnehmer',
                'Anzahl der Teilnehmerinnen'
            ]
        },
        chart2: {
            title: 'So häufig trinken Sie…',
            sub: ['…im Vergleich zu den ', ' Teilnehmerinnen und Teilnehmern'],
            gender: ['Männer', 'Frauen']
        },
        chart3: {
            title: 'So häufig trinken Sie…',
            sub: ['…im Vergleich zur Schweizer Bevölkerung (BFS-Daten)'],
            gender: ['Männer', 'Frauen']
        },
        source: ['Quelle:', 'BFS']
    },
    footer: {
        questions: [
            'Wie informativ war der Beitrag?',
            'Wie unterhaltsam war er?',
            'Wie gut funktionierte die technische Umsetzung?'
        ],
        credits: [
            ['Konzeption und Umsetzung', 'Marc Brupbacher, Sebastian Broschinski']
        ]
    }
}
